import {NotFoundComponent}      from "./not-found/not-found.component";
import {HomeComponent}          from "./home/home.component";
import {RouterModule}           from "@angular/router";
import {NotificationsComponent} from "./notifications/notifications.component";
import {AuthenticationGuard} from "./guards/authentication.guard";
import {SignInComponent} from "./signin/signin.component";
import {SignOutComponent} from "./signout/signout.component";
import {UsersComponent} from "./users/users.component";
import { CollectionComponent } from './collection/collection.component';
import { JewlaryComponent } from './jewlary/jewlary.component';

/**
 * Created by maty on 13/02/2017.
 */

export const rootRouting = RouterModule.forRoot([
    { path: 'sign-in',          component: SignInComponent },
    { path: 'sign-out',         component: SignOutComponent,        canActivate: [AuthenticationGuard] },

    { path: '',                 component: HomeComponent,           canActivate: [AuthenticationGuard] },
    { path: 'notifications',    component: NotificationsComponent,  canActivate: [AuthenticationGuard] },
    { path: 'collections',      component: CollectionComponent,     canActivate: [AuthenticationGuard] },
    { path: 'jewelries',        component: JewlaryComponent,        canActivate: [AuthenticationGuard] },
    { path: 'users',            component: UsersComponent,          canActivate: [AuthenticationGuard] },
    { path: '**',               component: NotFoundComponent,       canActivate: [AuthenticationGuard] }
]);



// WEBPACK FOOTER //
// ./src/app/app.routing.ts